<template>
  <b-container fluid>
    <b-row class="mt-2">
      <b-col>
        <b-card>
          <el-row :gutter="10">
            <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
              <span class="group-title"
                >Bill No：{{ formData.fabricRequestNo }}</span
              >
            </el-col>
            <!-- <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
              <span class="group-title"
                >Status：{{ formData.fabricRequestStatusName }}</span
              >
            </el-col> -->
            <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
              <span class="group-title"
                >Bill time：{{ formData.modifyDate }}</span
              >
            </el-col>
          </el-row>
          <div class="d2-mt" id="body">
            <el-form ref="formData" :model="formData">
              <el-row :gutter="10">
                <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
                  <el-form-item :label="'业务员'" size="small">
                    <el-input
                      v-model="formData.fabricAgentName"
                      size="small"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
                  <el-form-item :label="'客户'" size="small">
                    <el-input
                      v-model="formData.custName"
                      size="small"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
                  <el-form-item :label="'供应商'" size="small">
                    <el-input
                      v-model="formData.scmName"
                      size="small"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col
                  :xs="{ span: 12 }"
                  :sm="{ span: 24 }"
                  :md="{ span: 12 }"
                  :lg="{ span: 8 }"
                >
                  <el-form-item :label="'工厂联系人'" size="small">
                    <el-input
                      v-model="formData.contactName"
                      size="small"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col
                  :xs="{ span: 12 }"
                  :sm="{ span: 24 }"
                  :md="{ span: 12 }"
                  :lg="{ span: 8 }"
                >
                  <el-form-item :label="'联系人手机'" size="small">
                    <el-input
                      v-model="formData.contactMobile"
                      size="small"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col
                  :xs="{ span: 12 }"
                  :sm="{ span: 24 }"
                  :md="{ span: 12 }"
                  :lg="{ span: 4 }"
                >
                  <el-form-item :label="'开发依赖日期'" size="small">
                    <el-input
                      v-model="formData.requestDate"
                      size="small"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col
                  :xs="{ span: 12 }"
                  :sm="{ span: 24 }"
                  :md="{ span: 12 }"
                  :lg="{ span: 4 }"
                >
                  <el-form-item :label="'要求完成日期'" size="small">
                    <el-input
                      v-model="formData.finishDate"
                      size="small"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 8 }">
                  <el-form-item :label="'面料用途'" size="small">
                    <el-input
                      v-model="formData.fabricUse"
                      size="small"
                      readonly
                      type="textarea"
                      :autosize="{ minRows: 3, maxRows: 3 }"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :sm="{ span: 24 }" :md="{ span: 24 }" :lg="{ span: 8 }">
                  <el-form-item :label="'备注'" size="small">
                    <el-input
                      v-model="formData.fabricMemo"
                      size="small"
                      readonly
                      type="textarea"
                      :autosize="{ minRows: 3, maxRows: 3 }"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div class="d2-mt">
            <div class="side-frame-success group-title">
              {{ '面料信息' }} FabricNo：{{ formData.fabricNo }}
            </div>
            <el-form ref="formData" :model="formData">
              <el-row :gutter="10">
                <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
                  <el-form-item :label="'面料名称'" size="small">
                    <el-input
                      v-model="formData.fabricName"
                      size="small"
                      readonly
                      type="textarea"
                      :autosize="{ minRows: 2, maxRows: 2 }"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
                  <el-form-item :label="'英文名称'" size="small">
                    <el-input
                      v-model="formData.fabricNameEn"
                      size="small"
                      readonly
                      type="textarea"
                      :autosize="{ minRows: 2, maxRows: 2 }"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
                  <el-form-item :label="'成分'" size="small">
                    <el-input
                      v-model="formData.fabricContent"
                      size="small"
                      readonly
                      type="textarea"
                      :autosize="{ minRows: 2, maxRows: 2 }"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col
                  :xs="{ span: 12 }"
                  :sm="{ span: 12 }"
                  :md="{ span: 12 }"
                  :lg="{ span: 8 }"
                >
                  <el-form-item :label="'门幅'" size="small">
                    <el-input
                      v-model="formData.widText"
                      size="small"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col
                  :xs="{ span: 12 }"
                  :sm="{ span: 12 }"
                  :md="{ span: 12 }"
                  :lg="{ span: 8 }"
                >
                  <el-form-item :label="'面料克重'" size="small">
                    <el-input
                      v-model="formData.fabricWeightText"
                      size="small"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col
                  :xs="{ span: 12 }"
                  :sm="{ span: 12 }"
                  :md="{ span: 12 }"
                  :lg="{ span: 8 }"
                >
                  <el-form-item :label="'密度'" size="small">
                    <el-input
                      v-model="formData.density"
                      size="small"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col
                  :xs="{ span: 12 }"
                  :sm="{ span: 12 }"
                  :md="{ span: 12 }"
                  :lg="{ span: 8 }"
                >
                  <el-form-item :label="'纱支'" size="small">
                    <el-input
                      v-model="formData.yarnCount"
                      size="small"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col
                  :xs="{ span: 12 }"
                  :sm="{ span: 24 }"
                  :md="{ span: 12 }"
                  :lg="{ span: 8 }"
                >
                  <el-form-item :label="'单价'" size="small">
                    <el-input
                      v-model="formData.unitPriceText"
                      size="small"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col
                  :xs="{ span: 12 }"
                  :sm="{ span: 24 }"
                  :md="{ span: 12 }"
                  :lg="{ span: 8 }"
                >
                  <el-form-item :label="'需求总数量'" size="small">
                    <el-input
                      v-model="formData.requestQuantityText"
                      size="small"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col
                  :xs="{ span: 12 }"
                  :sm="{ span: 24 }"
                  :md="{ span: 12 }"
                  :lg="{ span: 8 }"
                >
                  <el-form-item :label="'面料金额'" size="small">
                    <el-input
                      v-model="formData.requestAmount"
                      size="small"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col
                  :xs="{ span: 12 }"
                  :sm="{ span: 24 }"
                  :md="{ span: 12 }"
                  :lg="{ span: 8 }"
                >
                  <el-form-item :label="'附加费'" size="small">
                    <el-input
                      v-model="formData.requestFee"
                      size="small"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 8 }">
                  <el-form-item :label="'合计金额'" size="small">
                    <el-input
                      v-model="formData.requestTotalAmount"
                      size="small"
                      readonly
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div class="side-frame-success group-title d2-mt">
            {{ '面料颜色' }}
          </div>
          <colors ref="colors" :main-type="type" :params="params" />
          <!--图片信息-->
          <div class="side-frame-success group-title d2-mt">
            {{ '面料图片' }}
          </div>
          <div class="mt-2" v-if="imageList">
            <swiper :options="swiperOption">
              <swiper-slide
                v-for="(itemImage, index) in imageList"
                :key="index"
              >
                <div class="swiper-zoom-container">
                  <img
                    :src="itemImage.frThumbImageUrl"
                    @click="imageView(index, imageList)"
                  />
                </div>
              </swiper-slide>
              <!-- <div class="swiper-pagination" slot="pagination"></div>
              <div class="swiper-button-prev" slot="button-prev">
                <i class="fa fa-chevron-circle-left icon-font" />
              </div>
              <div class="swiper-button-next" slot="button-next">
                <i class="fa fa-chevron-circle-right icon-font" />
              </div> -->
            </swiper>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <div v-show="false" ref="viewBigVisitImage" v-viewer="{ movable: true }">
      <img
        v-for="src in imageList"
        :src="src.frImageUrl"
        :key="src.frImageCode"
      />
    </div>
  </b-container>
</template>
<script>
import colors from './fabricColor/list'
export default {
  name: 'opview-fabricrequest-info',
  components: {
    colors,
  },
  data() {
    return {
      functionOptions: [], //功能
      constructionOptions: [], //材料备注
      fabricDescriptionOptions: [], //面料名称
      patternOptions: [], //花型
      techniqueOptions: [], //工艺
      chooseMADVisible: false,
      pageHeader: '',
      dialogVisible: false,
      disabled: true,
      fabricDisabled: true,
      formData: {
        fabricRequestCode: '',
        functionArray: [], //功能
        constructionArray: [], //材料备注
        fabricDescriptionArray: [], //面料名称
        patternArray: [], //花型
        techniqueArray: [], //工艺
        fabricCode: '',
        fabricNo: '',
        fabricName: '',
        fabricNameEn: '',
        fabricCategoryCode: '',
        fabricAttributes: '',
        fabricContent: '',
        fabricContentEn: '',
        fabricRequestStatusName: '',
        categoryCode: '',
        supCode: '',
        requestDate: '',
        finishDate: '',
        contactName: '',
        contactMobile: '',
        fabricAgentCode: '',
        wid: '',
        yarnCount: '',
        fabricWeight: '',
        density: '',
        requestQuantity: '',
        requestAmount: '',
        fabricUnit: '',
        unitPrice: '',
        widUnit: '',
        fabricWeightUnit: '',
        isMulticolor: 'Y',
        isInStock: 'N',
        fabricUse: '',
        fabricMemo: '',
        createDate: '',
        createByName: '',
        modifyDate: '',
        modifyByName: '',
        auditByName: '',
        auditDate: '',
      },
      imageList: [],
      swiperOption: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 10,
        loop: false,
        loopFillGroupWithBlank: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      requestQuantityPlaceholder: '',
      params: {
        fabricRequestCode: '',
      },
      categoryOption: [],
      type: '',
    }
  },
  computed: {},
  mounted() {
    if (this.$route.params.fabricRequestCode) {
      let param = { fabricRequestCode: this.$route.params.fabricRequestCode }
      this.loadData(param)
    }
  },
  activated() {
    if (this.$route.params.fabricRequestCode) {
      // this.init(
      //   this.$route.params.pageType,
      //   this.$route.params.fabricRequestCode
      // )
    }
  },
  beforeCreate() {
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#f1f1f1;')
  },
  methods: {
    loadData(param) {
      this.$api.fabricRequestH5ViewDetailApi(param).then((res) => {
        this.params.fabricRequestCode = res.body.fabricRequestCode
        this.formData = res.body
        if (this.formData.fabricNo) {
          this.fabricDisabled = true
        }

        this.$refs.colors.load({
          fabricRequestCode: res.body.fabricRequestCode,
        })
        this.imageList = res.body.imageList
      })
    },
    detailLoad(fabricRequestCode) {
      this.type = 'detail'
      this.pageHeader = '面料开发申请单详情'
      this.disabled = true
      this.fabricDisabled = true
      let param = { fabricRequestCode: fabricRequestCode }
      this.loadData(param)
    },

    isMulticolorChange() {
      if (this.formData.isMulticolor === 'Y') {
        this.formData.requestQuantity = ''
        this.requestQuantityPlaceholder = '系统计算'
      } else {
        this.requestQuantityPlaceholder = '请输入...'
      }
    },
    // 点击大图显示图片预览组件
    imageView(index, imageList) {
      if (imageList.length > 0) {
        const viewer = this.$refs.viewBigVisitImage.$viewer
        this.viewerImageList = imageList
        viewer.view(index)
        viewer.show()
      }
    },
    backSave() {
      this.dialogVisible = false
    },
    goBack() {
      if (this.disabled) {
        this.back()
        return
      }
      this.dialogVisible = true
    },
    back() {
      history.back()
      this.dialogVisible = false
      this.reset()
    },
    reset() {
      this.functionOptions = [] //功能
      this.constructionOptions = [] //材料备注
      this.fabricDescriptionOptions = [] //面料名称
      this.patternOptions = [] //花型
      this.techniqueOptions = [] //工艺
      this.type = ''
      this.categoryOption = []
      this.chooseMADVisible = false
      this.dialogVisible = false
      this.formData = {
        functionArray: [], //功能
        constructionArray: [], //材料备注
        fabricDescriptionArray: [], //面料名称
        patternArray: [], //花型
        techniqueArray: [], //工艺
        fabricRequestCode: '',
        fabricCode: '',
        fabricNo: '',
        fabricName: '',
        fabricNameEn: '',
        fabricCategoryCode: '',
        fabricAttributes: '',
        fabricContent: '',
        fabricContentEn: '',
        fabricRequestStatusName: '',
        categoryCode: '',
        supCode: '',
        requestDate: '',
        finishDate: '',
        contactName: '',
        contactMobile: '',
        fabricAgentCode: '',
        wid: '',
        yarnCount: '',
        fabricWeight: '',
        density: '',
        requestQuantity: '',
        requestAmount: '',
        fabricUnit: '',
        unitPrice: '',
        widUnit: '',
        fabricWeightUnit: '',
        isMulticolor: 'Y',
        isInStock: 'N',
        fabricUse: '',
        fabricMemo: '',
        createDate: '',
        createByName: '',
        modifyDate: '',
        modifyByName: '',
        auditByName: '',
        auditDate: '',
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
.side-frame-success {
  padding: 1px 10px;
  border-left: 3px solid $color-success;
  margin: 15px 0;
}
.group-title {
  font-size: 14px;
  color: #606266;
}
.el-form-item {
  margin-bottom: 5px !important;
}
</style>
